import {Component} from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {
  BUILD,
  CONSULTANT,
  EVENT,
  EVENT_LANDING,
  MAIL,
  NEW,
  PENDING_ACTIONS,
  REPORT,
  REPORT_VIC,
  RESERVATION_ANOTHER,
  RESERVATION_LANDING,
  RESERVATION_MASS,
  RESERVATION_REPORT,
  RESTAURANT_LANDING,
  SERVICE,
  WATCH_LATER
} from './constants/icon';
import {UserService} from './services/user.service';
import {Event as RouterEvent, Router} from '@angular/router';
import {ROUTES} from './route/routes';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  testCookies: boolean = false;

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    public userService: UserService,
    private router: Router,
  ) {
    this.addSVGIcons();
    this.router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });
  }

  ngOnInit(): void {
    this.router.navigateByUrl(ROUTES.PRE_LANDING.absolute_path);
    if (this.userService.getCurrentUser() && this.userService.isExpiredToken) {
      this.userService.logout();
    }
  }

  logout() {
    this.userService.logout();
  }

  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {
    window.scroll(0, 0);
    /*if (event instanceof NavigationStart) {
        this.spinner.show();
    }
    if (event instanceof NavigationEnd) {
      setTimeout(() => {
        this.spinner.hide();
      }, 100);
    }
    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      setTimeout(() => {
        this.spinner.hide();
      }, 100);
    }
    if (event instanceof NavigationError) {
      setTimeout(() => {
        this.spinner.hide();
      }, 100);
    }*/
  }

  private addSVGIcons() {
    // LANDING
    //this.iconRegistry.addSvgIconLiteral('agency-home', this.sanitizer.bypassSecurityTrustHtml(AGENCY_LANDING));
    //this.iconRegistry.addSvgIconLiteral('bank-home', this.sanitizer.bypassSecurityTrustHtml(BANK_LANDING));
    //this.iconRegistry.addSvgIconLiteral('consultant-home', this.sanitizer.bypassSecurityTrustHtml(CONSULTANT_LANDING));
    //this.iconRegistry.addSvgIconLiteral('report-home', this.sanitizer.bypassSecurityTrustHtml(REPORT_LANDING));
    this.iconRegistry.addSvgIconLiteral('event-home', this.sanitizer.bypassSecurityTrustHtml(EVENT_LANDING));
    this.iconRegistry.addSvgIconLiteral('reservation-home', this.sanitizer.bypassSecurityTrustHtml(RESERVATION_LANDING));
    this.iconRegistry.addSvgIconLiteral('settings-home', this.sanitizer.bypassSecurityTrustHtml(SERVICE));
    this.iconRegistry.addSvgIconLiteral('restaurant-home', this.sanitizer.bypassSecurityTrustHtml(RESTAURANT_LANDING));

    // AGENCY
    this.iconRegistry.addSvgIconLiteral('new', this.sanitizer.bypassSecurityTrustHtml(NEW));
    this.iconRegistry.addSvgIconLiteral('build', this.sanitizer.bypassSecurityTrustHtml(BUILD));

    // BANK
    this.iconRegistry.addSvgIconLiteral('watch-later', this.sanitizer.bypassSecurityTrustHtml(WATCH_LATER));
    this.iconRegistry.addSvgIconLiteral('pending-actions', this.sanitizer.bypassSecurityTrustHtml(PENDING_ACTIONS));
    this.iconRegistry.addSvgIconLiteral('event', this.sanitizer.bypassSecurityTrustHtml(EVENT));
    this.iconRegistry.addSvgIconLiteral('mail', this.sanitizer.bypassSecurityTrustHtml(MAIL));

    // CONSULTANT
    this.iconRegistry.addSvgIconLiteral('associate-consultant', this.sanitizer.bypassSecurityTrustHtml(CONSULTANT));

    // REPORT
    this.iconRegistry.addSvgIconLiteral('report', this.sanitizer.bypassSecurityTrustHtml(REPORT));
    this.iconRegistry.addSvgIconLiteral('reportVIC', this.sanitizer.bypassSecurityTrustHtml(REPORT_VIC));

    // RESERVATION
    this.iconRegistry.addSvgIconLiteral('reservation-report', this.sanitizer.bypassSecurityTrustHtml(RESERVATION_REPORT));
    this.iconRegistry.addSvgIconLiteral('reservation-mass', this.sanitizer.bypassSecurityTrustHtml(RESERVATION_MASS));
    this.iconRegistry.addSvgIconLiteral('reservation-another', this.sanitizer.bypassSecurityTrustHtml(RESERVATION_ANOTHER));

    // SETTINGS
    this.iconRegistry.addSvgIconLiteral('service', this.sanitizer.bypassSecurityTrustHtml(SERVICE));

    // OTHER
    //
  }

}
